import { render, staticRenderFns } from "./ConfigurationsTab.vue?vue&type=template&id=4851b53d&scoped=true&"
import script from "./ConfigurationsTab.vue?vue&type=script&lang=js&"
export * from "./ConfigurationsTab.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationsTab.vue?vue&type=style&index=0&id=4851b53d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851b53d",
  null
  
)

export default component.exports